import { computed } from 'vue'
import { useOrganizationOnboarding } from '@/features/organizations/queries/useOrganizationOnboarding'
import { can } from '@/lib/permissions/can'
import { Permission } from '@/lib/permissions/keys'
import { useWorkspaceStore } from '@/stores/workspace'

/**
 * The selected organization's onboarding, and the step its card shows (null when it shows none).
 * `isCardPossible` stays true while a user who may see the card waits for the answer.
 */
export function useOrganizationOnboardingStep() {
  const workspace = useWorkspaceStore()

  // The endpoint takes an organization-level grant; a workspace-level user would get a 403.
  const organizationId = computed(() => {
    const id = workspace.currentOrganizationId

    return id !== null && can(Permission.OrganizationGet, { organizationId: id })
      ? Number(id)
      : null
  })
  const { data, isPending } = useOrganizationOnboarding(organizationId)

  const step = computed(() => {
    const onboarding = data.value

    return onboarding?.required && onboarding.step !== 'completed' ? onboarding.step : null
  })
  const isCardPossible = computed(
    () => step.value !== null || (organizationId.value !== null && isPending.value),
  )

  return { data, step, isCardPossible }
}
